import React, { Component } from 'react';
import { connect } from "react-redux";


import { CrossIconSmall, DownloadIcon } from "./icons";

import { removeFilterAndApply } from "../core/actions/filtering";
import { formatValueFromMapping } from "../utils/misc";
import DjangoCSRFToken from '../../components/django-react-csrftoken';


export const _ActiveFilterBar = ({ activeFilters, searchQuery, filterDownloadUrl, editingEnabled }) => (
    <div>
        { ( activeFilters.length > 0 || searchQuery !== '' ) &&
            <div className="u-bg-color-grey" id="active-filters">
                <div className="wrapper u-flex flex--center">
                    <ActiveFiltersList />
                    { editingEnabled || ( filterDownloadUrl && <ActiveFiltersDownload /> ) }
                </div>
            </div>
        }
    </div>
);

export const ActiveFilterBar = connect(state => ({
    activeFilters: state.mutableFiltering.activeFilters,
    searchQuery: state.mutableSearching.searchQuery,
    editingEnabled: state.immutableEditing.editingEnabled,
    filterDownloadUrl: state.immutableBaseData.filterDownloadUrl,
}))(_ActiveFilterBar);


const _ActiveFiltersList = ({ dispatch, activeFilters, valueMapping }) => (
    <ul className="u-flex u-flex-1 flex--wrap u-m-reset u-p--reset u-list-style-none">
        { activeFilters.map((item) => (
            <li key={ item.field + '.' + item.value } className="u-p--reset u-m-reset">
                <button name={ item.field + '.' + item.value }
                        className="u-flex flex--center btn btn--secondary--small--white u-mtb--xxsmall u-mr--xxsmall"
                        onClick={ () => dispatch( removeFilterAndApply(item.field, item.value) ) }
                >
                    <span className="u-pr--xsmall u-font-size--">
                        { formatValueFromMapping(item.value, item.field, valueMapping) }
                    </span>
                    &nbsp;
                    <CrossIconSmall />
                </button>
            </li>
        ))}
    </ul>
);

const ActiveFiltersList = connect(state => ({
    valueMapping: state.immutableBaseData.valueFormatterMapping,
    activeFilters: state.mutableFiltering.activeFilters,
}))(_ActiveFiltersList);


const _ActiveFiltersDownload = ({ filterDownloadUrl, activeRowKeys }) => (
    <form method="POST" action={ filterDownloadUrl } id="filtered-download-form" className="u-mt-0" >
        <DjangoCSRFToken />
        <input name="row_keys" type="text" hidden="true" value={ activeRowKeys } readOnly="true"/>
        <button
            className="u-font-size-- u-flex flex--center u-color-blue cursor-pointer u-m-reset u-mtb--xxsmall btn-reset"
            type="submit"
        >
            <span className="u-hidden xmd-block u-mr--xxsmall">Download filtered version</span>
            &nbsp;
            <DownloadIcon />
        </button>
    </form>
);

const ActiveFiltersDownload = connect(state => ({
    activeRowKeys: state.mutableSearching.searchedRowKeys,
    filterDownloadUrl: state.immutableBaseData.filterDownloadUrl,
}))(_ActiveFiltersDownload);
